import HeltHjem from 'resources/icons/HeltHjemLogo';
import PostNordLogo from 'resources/icons/PostNordLogo';
import ShippingInTransitIcon from 'resources/icons/ShippingInTransit';
import pulseClient from 'resources/pulse';
import { ShippingInfoType } from 'types/uiTypes';
import ExpandableDataContainer from './ExpandableDataContainer';

type Props = {
    shippingInfo: ShippingInfoType;
};
type ContentProp = {
    content: { title: string; text: string };
};

const Content = ({ content }: ContentProp) => {
    const isHeltHjem = content.title === 'Helthjem';

    return (
        <div className="flex items-center space-x-8 text-14 my-24 md:my-0">
            {isHeltHjem ? <HeltHjem /> : <PostNordLogo />}
            <div>
                <p className="font-bold m-0">{content.title}</p>
                <p className="m-0">{content.text}</p>
            </div>
        </div>
    );
};

const ShippingInfo = ({ shippingInfo }: Props) => {
    const { title, helthjem, postnord } = shippingInfo;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const provider = (helthjem || postnord)!;

    return (
        <ExpandableDataContainer
            icon={<ShippingInTransitIcon />}
            title={title}
            tracker={pulseClient.trackExpandShipping}
        >
            <Content content={provider} />
        </ExpandableDataContainer>
    );
};

export default ShippingInfo;
